export default __webpack_public_path__ + "static/media/Could_not_load_tweet.c312e39f.svg";